import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import { BaseConversationalLeadPage, CarleadHIWWhyChooseWkdaFaq, MatomoHelmet, } from '@wkda/marketing-components';
import { defaultFlowWithoutConsent } from '@wkda/conversational-carlead';

function CarleadCreation() {
  return (
    <>
      <MatomoHelmet />
      <BaseConversationalLeadPage
        form={defaultFlowWithoutConsent}
        content={CarleadHIWWhyChooseWkdaFaq}
        showTrustPilot={true}
      />
    </>
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
